import { Product, Variant } from "../../types/types";
import {
  isVariantReducedToClear,
  isVariantPromotional,
  isAllVariantsReduced,
  isAllVariantsSave,
  isAllVariantsReducedForColour,
  isSomeVariantsReducedForColour,
  isAllVariantsSaveForColour,
  isSomeVariantsSaveForColour,
} from "./promotionUtils";
import { getColourGroupForVariant } from "../../utils/product/getColourGroupForVariant";

export const getSizeReductionLabelInfo = (
  product: Product,
  sizeVariant: Variant,
  showSaveLabels: boolean,
) => {
  const variants: Variant[] = product.variants;
  if (isAllVariantsReduced(product) || isAllVariantsSave(product)) {
    return { showReduced: false, label: "" };
  }

  const isReducedToClear = isVariantReducedToClear(sizeVariant);
  const isSave = isVariantPromotional(sizeVariant);

  if (!(variants[0] as Variant).differentiators?.colour) {
    return {
      showReduced: isReducedToClear || isSave,
      label: isReducedToClear
        ? "Reduced"
        : isSave && showSaveLabels
          ? "Offer"
          : "",
    };
  }

  const variantGroup = getColourGroupForVariant(
    product.variantGroups,
    sizeVariant.id,
  );

  if (isSomeVariantsReducedForColour(variantGroup)) {
    return {
      showReduced: isReducedToClear,
      label: isReducedToClear ? "Reduced" : "",
    };
  }
  if (isAllVariantsReducedForColour(variantGroup)) {
    return { showReduced: false, label: "" };
  }
  if (isSomeVariantsSaveForColour(variantGroup)) {
    return {
      showReduced: isSave,
      label: isSave && showSaveLabels ? "Offer" : "",
    };
  }
  if (isAllVariantsSaveForColour(variantGroup)) {
    return { showReduced: false, label: "" };
  }

  return { showReduced: false, label: "" };
};
